import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id, PagedParams, PagedResponse, getQueryKey } from '@feature/utils';

import * as api from './ConferenceApi';
import { Conference, ConferenceRequest } from './ConferenceTypes';

const conferenceKey = getQueryKey('conference');

export function getConferencePagedOptions(params: PagedParams): UseSuspenseQueryOptions<PagedResponse<Conference>> {
  return {
    queryKey: conferenceKey.paged(params),
    queryFn: () => api.getPaged(params),
  };
}

export function getConferenceOptions(conferenceId: Id): UseSuspenseQueryOptions<Conference> {
  return {
    queryKey: conferenceKey.one(conferenceId),
    queryFn: () => api.get(conferenceId),
  };
}

export function useConferenceEdit(conferenceId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ConferenceRequest) => api.edit(conferenceId, request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: conferenceKey.root(),
      }),
  });
}

export function useConferenceCreate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ConferenceRequest) => api.create(request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: conferenceKey.root(),
      }),
  });
}

export function useConferenceDelete(conferenceId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.deleteById(conferenceId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: conferenceKey.root(),
      }),
  });
}
